import { Injectable } from '@angular/core';
import { deviceStatus } from '@caslink/common-client';
import { StateService } from '@uirouter/core';
import { IDeviceStatusListSearchCriteria } from '../models/device-status-list-search-criteria.interface';

@Injectable({
    providedIn: 'root'
})
export class DeviceStatusViewInfoQueryService {
    public static $name: string = 'deviceStatusViewInfoQueryService';

    private _query: IDeviceStatusListSearchCriteria;

    constructor(private $state: StateService) { }

    public clearQuery() {
        this._query = null;
    }

    public setQuery(query: IDeviceStatusListSearchCriteria) {
        if (this.$state.current.name === deviceStatus.deviceStatusArea || this.$state.current.name === deviceStatus.deviceSearch) {
            query.$cached = true;
            this._query = query;
        }
    }

    public getQuery(): IDeviceStatusListSearchCriteria {
        if (this.$state.current.name === deviceStatus.deviceStatusArea || this.$state.current.name === deviceStatus.deviceSearch) {
            const query = this._query;
            this._query = null;

            return query;
        }
        return null;
    }
}
